import { createRequestTypes } from '../utils';

export const WORK_ITEM_LIST = createRequestTypes('workItem/WORK_ITEM_LIST');
export const SAVE_WORK_ITEM = createRequestTypes('workItem/SAVE_WORK_ITEM');
export const DELETE_WORK_ITEM = createRequestTypes('workItem/DELETE_WORK_ITEM');
